// hooks/useCotaUsuario.ts
import { useState, useEffect } from "react";
import { representanteService } from "../services/representanteService";
import { Representante } from "../interfaces/Representante";

export const useRepresentante = (
  usuarioId: number | null | undefined,
  fetch: boolean
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [representante, setRepresentante] = useState<Representante | undefined>(
    undefined
  );

  useEffect(() => {
    const fetchRepresentante = async () => {
      if (usuarioId && fetch) {
        setIsLoading(true);
        try {
          const data = await representanteService(usuarioId);
          if (data !== null) {
            setRepresentante(data);
          }
        } catch (error) {
          console.error("Erro ao buscar representante:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchRepresentante();
  }, [usuarioId, fetch]); // Dependência de usuarioId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, representante };
};
